import { Component, EventEmitter, Input, Output, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SearchService } from '../common/services/search.service';
import { JwtService } from '../common/services/jwt.service';
import * as _ from 'lodash';

@Component({
  selector: 'profile-map',
  templateUrl: './profile-map.component.html',
  styleUrls: ['./profile-map.component.css'],
})
export class ProfileMapComponent {
  url;
  loading = false

  // Tableau
  renderTableau = true;
  tableauJWT: string;
  @Input() header = '';
  @Input() collapsed = false;
  @Output() collapsedChange: EventEmitter<boolean>;
  @Input() visible = false;
  @Input() id;
  @Input() mapProfile = '';
  @Input() filter;
  @Input() filterProfileBy;
  @Input() searchTerm = '';
  @Input() searchState = '';
  @Input() cityNames = '';
  @Input() countyNames = '';
  @Input()
  set mySearchResults(searchObj) {
    this.loading = true
    this.cityNames = "";
    var selectedCities = searchObj.cities.filter((city) => city.selected)
    for (let i = 0; i < selectedCities.length;) {
      this.cityNames = this.cityNames.concat(selectedCities[i].name);
      if (++i < selectedCities.length) {
        this.cityNames += ",";
      }
    }
    this.countyNames = "";
    var selectedCounties = searchObj.counties.filter((county) => county.selected)
    for (let i = 0; i < selectedCounties.length;) {
      this.countyNames = this.countyNames.concat(selectedCounties[i].name);
      if (++i < selectedCounties.length) {
        this.countyNames += ",";
      }
    }

    this.forceRerender()
    this.loading = false
  }

  constructor(
    public sanitizer: DomSanitizer,
    private searchService: SearchService,
    private jwtService: JwtService,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    this.collapsedChange = new EventEmitter<boolean>();
    this.searchService.newSearch.subscribe((status: string) => {
      if (status === 'New Search') {
        this.forceRerender()
      }
    });

    this.jwtService.getToken().subscribe(token => {
      this.tableauJWT = token;
    });
  }

  toTitleCase(str) {
    if (_.isEmpty(str)) {
      return '';
    }
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }


  forceRerender() {
    let jwtExpired = this.jwtService.isTokenExpired(this.tableauJWT)
    if (jwtExpired) {
      this.jwtService.refreshToken()
    }
    this.renderTableau = false
    setTimeout(() => {
      this.renderTableau = true
    }, 0);
  }


  private _vizFilterSearchTerm: ElementRef;
  @ViewChild('vizFilterSearchTerm')
  set vizFilterSearchTerm(element: ElementRef) {
    let capitalizeSearchTerm = this.toTitleCase(this.searchTerm);
    this._vizFilterSearchTerm = element;
    if (this._vizFilterSearchTerm) {
      this.renderer.setAttribute(this._vizFilterSearchTerm.nativeElement, 'value', capitalizeSearchTerm);
    }
  }

  private _vizFilterState: ElementRef;
  @ViewChild('vizFilterState')
  set vizFilterState(element: ElementRef) {
    this._vizFilterState = element;
    if (this._vizFilterState) {
      let ss = ''
      if (this.searchState === undefined || this.searchState === null) {
        ss = ''
      } else {
        ss = this.searchState
      }
      this.renderer.setAttribute(this._vizFilterState.nativeElement, 'value', ss);
    }
  }

  private _vizFilterCity: ElementRef;
  @ViewChild('vizFilterCity')
  set vizFilterCity(element: ElementRef) {
    this._vizFilterCity = element;
    if (this._vizFilterCity) {
      let cn = ''
      if (this.cityNames === undefined || this.cityNames === null) {
        cn = ''
      } else {
        cn = this.cityNames
      }
      this.renderer.setAttribute(this._vizFilterCity.nativeElement, 'value', cn);
    }
  }

  private _vizFilterCounty: ElementRef;
  @ViewChild('vizFilterCounty')
  set vizFilterCounty(element: ElementRef) {
    this._vizFilterCounty = element;
    if (this._vizFilterCounty) {
      let cn = ''
      if (this.countyNames === undefined || this.countyNames === null) {
        cn = ''
      } else {
        cn = this.countyNames
      }
      this.renderer.setAttribute(this._vizFilterCounty.nativeElement, 'value', cn);
    }
  }

  private _vizFilterSearchTermFilterProfileBy: ElementRef;
  @ViewChild('vizFilterSearchTermFilterProfileBy')
  set vizFilterSearchTermFilterProfileBy(element: ElementRef) {
    let capitalizeSearchTerm = this.toTitleCase(this.searchTerm);
    this._vizFilterSearchTermFilterProfileBy = element;
    if (this._vizFilterSearchTermFilterProfileBy) {
      this.renderer.setAttribute(this._vizFilterSearchTermFilterProfileBy.nativeElement, 'value', capitalizeSearchTerm);
    }
  }

  private _vizFilterStateFilterProfileBy: ElementRef;
  @ViewChild('vizFilterStateFilterProfileBy')
  set vizFilterStateFilterProfileBy(element: ElementRef) {
    this._vizFilterStateFilterProfileBy = element;
    let ss = ''
    if (this.searchState === undefined || this.searchState === null) {
      ss = ''
    } else {
      ss = this.searchState
    }
    if (this._vizFilterStateFilterProfileBy) {
      this.renderer.setAttribute(this._vizFilterStateFilterProfileBy.nativeElement, 'value', ss);
    }
  }

  private _vizFilterCityFilterProfileBy: ElementRef;
  @ViewChild('vizFilterCityFilterProfileBy')
  set vizFilterCityFilterProfileBy(element: ElementRef) {
    this._vizFilterCityFilterProfileBy = element;
    let cn = ''
    if (this.cityNames === undefined || this.cityNames === null) {
      cn = ''
    } else {
      cn = this.cityNames
    }
    if (this._vizFilterCityFilterProfileBy) {
      this.renderer.setAttribute(this._vizFilterCityFilterProfileBy.nativeElement, 'value', cn);
    }
  }

  private _vizFilterCountyFilterProfileBy: ElementRef;
  @ViewChild('vizFilterCountyFilterProfileBy')
  set vizFilterCountyFilterProfileBy(element: ElementRef) {
    this._vizFilterCountyFilterProfileBy = element;
    if (this._vizFilterCountyFilterProfileBy) {
      this.renderer.setAttribute(this._vizFilterCountyFilterProfileBy.nativeElement, 'value', this.countyNames);
    }
  }

  private _tableauSearchURL: string = 'https://us-west-2b.online.tableau.com/#/site/aha/views/Maps/Search';

  get tableauSearchURL(): string {
    return this._tableauSearchURL;
  }

  set tableauSearchURL(value: string) {
    this._tableauSearchURL = value;
  }

  onClick() {
    this.collapsedChange.emit(!this.collapsed);
  }
}



// WEBPACK FOOTER //
// ./src/app/profile-map/profile-map.component.ts